import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import {
  ComponentFacadeParams,
  ReportComponentExportType,
  ReportDashboardExportType,
} from '@core/reports-types';

/**
 * Contract for report exports functionality.
 * Enables domain-specific implementations (e.g., recruitee has exports enabled, tellent disabled).
 */
export interface ReportsExportsFacadeService {
  exportComponent: (
    componentFacadeParams: ComponentFacadeParams,
    exportType: ReportComponentExportType,
  ) => Observable<void>;

  exportDashboard: (dashboardId: number, exportType: ReportDashboardExportType) => Observable<void>;

  canExportDashboard: (dashboardId: number) => Observable<boolean>;
}

export const { inject: injectReportsExportsFacade, provide: provideReportsExportsFacade } =
  createProviderToken<ReportsExportsFacadeService>('ReportsExportsFacadeService')();
